import React, { useEffect, useState } from "react";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { DB_POSTFIX } from "../../utils";

const AnnouncementBox = () => {
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(
        `${ServiceUrl.LIST_PAGES}?sadb=${DB_POSTFIX}&type=announcement&upcoming=1`
      )
      .then((res) => {
        if (res.data.status === "1") {
          setDataList(res.data.data);
        }
        setLoader(false);
      });
  };

  const marqueeMouseOver = () => {
    document.getElementById("adm_top_marquee").stop();
  };

  const marqueeMouseOut = () => {
    document.getElementById("adm_top_marquee").start();
  };

  const getHtmlContent = (item) => {
    return item?.content_html || "";
  };

  return (
    <div className="announcement-box">
      <h6 className="announcement-title">Announcements</h6>

      {loader ? (
        <div className="text-center py-3">Loading...</div>
      ) : dataList.length > 0 ? (
        <marquee
          id="adm_top_marquee"
          direction="up"
          scrollamount="3"
          onMouseOver={marqueeMouseOver}
          onMouseOut={marqueeMouseOut}
          className="announcement-marquee"
        >
          <ul className="list-unstyled mb-0">
            {dataList.map((item, index) => (
              <li key={index} className="announcement-item">
                <span className="date">
                  {item.created_on?.split(" ")[0] || ""}
                </span>
                <span
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: getHtmlContent(item),
                  }}
                />
              </li>
            ))}
          </ul>
        </marquee>
      ) : (
        <div className="text-center py-2">No announcements</div>
      )}
      <div className="footer-btn">
        <a href="/announcements-list">View All</a>
      </div>
    </div>
  );
};

export default AnnouncementBox;
